import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getTransactionList(params) {
	return client.get("member/transaction/stockist", {
		params: params,
	});
}

function getTransactionPendingList(params) {
	return client.get("member/transaction/stockist/pending", {
		params: params,
	});
}

function getTransactionDetail(params) {
	return client.get("member/transaction/detail", {
		params: params,
	});
}

function approveTransaction(params) {
	return client.post("member/transaction/approval_stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function rejectTransaction(params) {
	return client.post("member/transaction/reject_stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getSerialType(params) {
	return client.get("member/serial/type", {
		params: params,
	});
}

function getSerialList(params) {
	return client.get(`member/serial/stock_stockist/${params.id}`, {
		params: params.params,
	});
}

function sendSerial(params) {
	return client.post("member/serial/send_stockist", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getHistorySerialList(params) {
	return client.get(`member/serial/history_stockist/${params.id}`, {
		params: params.params,
	});
}

function getDetailHistorySerialList(params) {
	return client.get(`member/serial/detail_history_stockist/${params.id}`, {	
		params: params.params,
	});
}

export default {
	getTransactionList,
	getTransactionPendingList,
	getTransactionDetail,
	approveTransaction,
	rejectTransaction,
	getSerialType,
	getSerialList,
	sendSerial,
	getHistorySerialList,
	getDetailHistorySerialList
};